import { render, staticRenderFns } from "./cheliang.vue?vue&type=template&id=5000aec0&scoped=true"
import script from "./cheliang.vue?vue&type=script&lang=js"
export * from "./cheliang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5000aec0",
  null
  
)

export default component.exports